import { Box, Text } from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"

interface LabelPopoverProps {
  editor: Editor
}

export function LabelPopover(props: LabelPopoverProps) {
  const { editor } = props

  const labelAttributes = editor.getAttributes("label")

  if (!labelAttributes["label"]) return null

  const label = labelAttributes["label"] as string
  return (
    <Box
      backgroundColor="purple9"
      padding={{ block: 2, inline: 4 }}
      alignItems="center"
      borderRadius={{ topLeft: 2, topRight: 2, bottomRight: 2 }}
      maxWidth={125}
    >
      <Text color="white" variant="small" noWrap>
        {label}
      </Text>
    </Box>
  )
}
